// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InlineMediaBlock_wrapper__r6Hgj"};